<div>
    <a class="btn qa-vAuto-btn" href="#" title="{{'vAutoCreateAppraisalButtonText' | translate}}" (click)="vautoModal()">
        <img src="../../../../images/asset-vauto.png" style="height:32px;width:auto;" />
    </a>
</div>
